import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',

  width: '42rem',
  backgroundColor: theme.colors.base07,
  border: `0.1rem solid ${theme.colors.base05}`,
  borderRadius: '1rem',

  color: theme.colors.base01,
}));

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',

  padding: '2.5rem ',
});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const Title = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const CloseImage = styled('div')({
  cursor: 'pointer',

  width: '2.4rem',
  height: '2.4rem',

  '& > svg': {
    width: '2.4rem',
    height: '2.4rem',
  },
});

export const RightArrow = styled('div')({
  cursor: 'pointer',

  width: '1.6rem',
  height: '1.6rem',

  '& > svg': {
    width: '1.6rem',
    height: '1.6rem',
  },

  marginLeft: '0.4rem',
});

export const ViewWrapper = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  marginTop: '2rem',

  textDecoration: 'none',

  color: theme.colors.base02,
}));

export const ErrorComment = styled('div')({
  marginTop: '1rem',

  color: '#FF4034',
  fontSize: '1.6rem',
});
